export function buildLeadPublicSubmissionCardData(submission) {
  if (!submission || typeof submission !== "object") return null;
  const fields = submission.fields && typeof submission.fields === "object" ? submission.fields : {};
  const submittedAt = submission.submitted_at || submission.privacy_accepted_at || "";
  const name = String(fields.name || "").trim();
  const email = String(fields.email || "").trim();
  if (!name || !email) return null;
  return {
    submittedAt,
    privacyAccepted: Boolean(submission.privacy_accepted),
    privacyAcceptedAt: submission.privacy_accepted_at || "",
    fields: {
      name,
      email,
      company: String(fields.company || "").trim(),
      phone: String(fields.phone || "").trim(),
      interest: String(fields.interest || "").trim(),
      message: String(fields.message || "").trim(),
    },
  };
}
